// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

export default interface IDebugSettings {
  isServer: boolean;
  port?: number;
  behaviorPackFolderName?: string;
}
